import {
    inject,
    Injectable
} from "@angular/core";

import {
    Notification
} from './iot-models'

import {
    ErrorsLoggerService
} from "src/app/core";

@Injectable({
    providedIn: 'root'
})
export class IotHistoryStorage {
    private readonly errorsLoggerService = inject(ErrorsLoggerService);

    public history = new Map<number, Notification>();
    public lastMessageId: number = 0;
    public firstMessageReceived: number = 0;
    public lastMessageIdChecked: number = 0;

    setStartHistory(msg_id: number) {
        this.firstMessageReceived = msg_id;
        this.lastMessageIdChecked = msg_id;
        this.history.clear();
    }

    private logger(...args: any[]){
        this.errorsLoggerService.debug("[IotHistoryStorage]: ", ...args);
    }

    getDiffLastAndFirst(){
        return this.lastMessageId - this.firstMessageReceived;
    }

    setList(list_messages: Notification[]): void {
        list_messages.forEach((m: Notification) => this.set(m));
        return;
    }

    set(message: Notification): void {
        this.history.set(message.msg_id, message);

        if (this.lastMessageId < message.msg_id) {
            this.lastMessageId = message.msg_id;
            this.logger("lastMessageId", this.lastMessageId, "firstMessageId", this.firstMessageReceived);
        }
        return;
    }

    unsetMessage(msg: Notification){
        if(this.lastMessageId === msg.msg_id){
            this.lastMessageId --;
        }

        this.history.delete(msg.msg_id);
    }
}